const headerCarriere = {
    init() {
        const breakpointResponsive = 992;
        const strate = $('.header-carriere');
        
        // si la strate existe
        if (strate) {
            const sliderItem = $('.header-carriere .wrapper_temoignage');
            const sliderWrapper = $('.header-carriere .wrapper_slider');

            if ($(window).width() < breakpointResponsive) {
                if (sliderItem.length > 1) {
                    headerCarriere.build(sliderWrapper);
                }
            }

            $(window).resize(
                function () {
                    if ($(window).width() < breakpointResponsive) {
                        if (sliderItem.length > 1) {
                            headerCarriere.build(sliderWrapper);
                        }
                    } else {
                        if (sliderItem.length > 1) {
                            headerCarriere.destroy(sliderWrapper);
                        }
                    }
                }
            );
        }
    },

    build(sliderWrapper) {
        sliderWrapper = sliderWrapper.addClass('owl-carousel');

        sliderWrapper.owlCarousel(
            {
                loop: true,
                margin: 20,
                items: 1,
                center: true,
                nav: false,
                dots: true,
                stagePadding: 0,
                autoWidth: false,
            }
        );
    },

    destroy(sliderWrapper) {
        sliderWrapper.trigger('destroy.owl.carousel');
        sliderWrapper.removeClass('owl-carousel');
    },
};

export default headerCarriere;
